import axios from 'axios';
import { ENTRYPOINT } from '../config/settings';

export const callAPI = axios.create({
    baseURL: ENTRYPOINT,
    headers: {
        'Accept': 'application/json',
    },
});

callAPI.interceptors.request.use(
    request => {
        const token = localStorage.getItem('token');
        if (token) {
            request.headers['Authorization'] = `Bearer ${token}`;
        }
        return request;
    },
    error => {
        return Promise.reject(error);
    }
);

callAPI.interceptors.response.use(
    response => response, // Directly return successful responses.
    async error => {
        const originalRequest = error.config;
        if (error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true; // Mark the request as retried to avoid infinite loops.
            try {
                // Make a request to your auth server to refresh the token.
                const response = await callAPI.post(`${ENTRYPOINT}/auth/refresh`, {
                    refresh_token: localStorage.getItem('refresh_token'),
                });
                const { token } = response.data;
                // Store the new access tokens.
                localStorage.setItem('token', token);
                // Update the authorization header with the new access token.
                callAPI.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                return callAPI(originalRequest); // Retry the original request with the new access token.
            } catch (refreshError) {
                // Handle refresh token errors by clearing stored tokens and redirecting to the login page.
                console.error('Token refresh failed');
                localStorage.removeItem('token');
                localStorage.removeItem('refresh_token');
                window.location.href = '/';
                return Promise.reject(refreshError);
            }
        }
        return Promise.reject(error); // For all other errors, return the error as is.
    }
);
